import axios from 'axios';
import { Dispatch } from 'redux';
import { Action } from '../interface';
import { FormCreate, FormEdit } from '../types';
import { ActionTypes, BACK } from './Action_Types';

export const getAllCountries = () => async (dispatch: Dispatch<Action>) => {
  try {
    const { data } = (await axios.get(BACK.countries));
    dispatch({
      type: ActionTypes.GET_ALL_COUNTRIES,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const searchByName = (name: string) => async (dispatch: Dispatch<Action>) => {
  try {
    const { data } = (await axios(`${BACK.countries}?name=${name}`));
    dispatch({
      type: ActionTypes.GET_COUNTRIES_BY_NAME,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

export const countryById = (id: string) => async (dispatch: Dispatch<Action>) => {
  try {
    const { data } = (await axios(`${BACK.countries}/${id}`));
    dispatch({
      type: ActionTypes.GET_COUNTRIES_BY_ID,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

export const createActivity = (post: FormCreate) => async (dispatch: Dispatch<Action>) => {
  try {
    let res = await axios.post(BACK.activities, post);
    dispatch({
      type: ActionTypes.CREATE_ACTIVITY,
      payload: res.data,
    });
  } catch (error) {
    console.log(`Error Action Post por: (${error})`);
  }
};

export const getAllActivities = () => async (dispatch: Dispatch<Action>) => {
  try {
    const { data } = (await axios.get(BACK.activities));
    dispatch({
      type: ActionTypes.GET_ALL_ACTIVITIES,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const deleteActivity = (id: number | undefined) => async (dispatch: Dispatch) => {
  try {
    const { data } = (await axios.delete(`${BACK.activities}/${id}`));
    console.log(data)
    dispatch<any>(getAllActivities())
  } catch (error) {
    console.log('Error en action delete por:', error);
  }
};

export const upDateActivity = (activity: FormEdit, id: string) => async (dispatch: Dispatch) => {
  try {
    let { data } = (await axios.put(`${BACK.activities}/${id}`, activity));
    console.log(data)
    return dispatch<any>(getAllActivities());
  } catch (error) {
    console.log('Error en action update por:', error);
  }
}

export const orderByName = (payload: string) => {
  try {
    return {
      type: ActionTypes.ORDER_BY_NAME,
      payload,
    }
  } catch (error) {
    console.log(error);
  }
};

export const orderByPopulation = (payload: string) => {
  return {
    type: ActionTypes.ORDER_BY_POPULATION,
    payload,
  };
};

export const filterByContinents = (payload: string) => {
  return {
    type: ActionTypes.FILTER_BY_CONTINENTS,
    payload,
  };
};

export const filterByActivities = (payload: string) => {
  return {
    type: ActionTypes.FILTER_BY_ACTIVITIES,
    payload,
  };
};